export const TestIds = {
  header: {
    logo: 'apply-header-logo',
    cta: 'apply-header-cta',
    languageSwitcher: 'apply-language-switcher',
    languageOption: (lang: string) => `apply-language-option-${lang}`,
  },
  hero: {
    badge: 'apply-hero-badge',
    title: 'apply-hero-title',
    cta: 'apply-hero-cta',
    statJobsPosted: 'apply-hero-stat-jobs-posted',
    statAvgResponse: 'apply-hero-stat-avg-response',
    statBusinesses: 'apply-hero-stat-businesses',
  },
  howItWorks: {
    title: 'apply-how-it-works-title',
    step: (n: number) => `apply-how-it-works-step-${n}`,
  },
  getHired: {
    title: 'apply-get-hired-title',
    industryCard: (clientId: string | number) =>
      `apply-get-hired-industry-${clientId}`,
    moreCompanies: 'apply-get-hired-more',
  },
  faq: {
    title: 'apply-faq-title',
    trigger: (idx: number) => `apply-faq-trigger-${idx}`,
    content: (idx: number) => `apply-faq-content-${idx}`,
  },
  applyForm: {
    section: 'apply-form-section',
    title: 'apply-form-title',
    industryTrigger: 'apply-form-industry-trigger',
    industryOption: (id: string | number) => `apply-form-industry-option-${id}`,
    positionTrigger: 'apply-form-position-trigger',
    positionOption: (id: string | number) => `apply-form-position-option-${id}`,
    firstName: 'apply-form-first-name',
    lastName: 'apply-form-last-name',
    phone: 'apply-form-phone',
    zipCode: 'apply-form-zip-code',
    submit: 'apply-form-submit',
    fieldError: (field: string) => `apply-form-error-${field}`,
  },
  finish: {
    title: 'apply-finish-title',
    messageLine1: 'apply-finish-message-1',
    messageLine2: 'apply-finish-message-2',
    seeYou: 'apply-finish-see-you',
    videoContainer: 'apply-finish-video',
  },
} as const;
